import PropTypes from 'prop-types';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext.js';
import { useLanguage } from '../../context/LanguageContext.js';
import './ThemeToggle.css';

/**
 * Theme toggle button.
 *
 * Variants mirror LanguageSwitcher so the two read as one control group:
 * - `header` (default) — translucent white glass pill for dark/gradient
 *   backgrounds such as the auth layout.
 * - `surface` — tinted surface pill for light card backgrounds.
 */
const ThemeToggle = ({ className = '', variant = 'header' }) => {
    const { isDarkTheme, toggleTheme } = useTheme();
    const { t } = useLanguage();

    return (
        <button
            type="button"
            className={`theme-toggle-btn theme-toggle-btn--${variant} ${className}`.trim()}
            onClick={toggleTheme}
            title={isDarkTheme ? t('header.switchToLight') : t('header.switchToDark')}
            aria-label={isDarkTheme ? t('header.switchToLight') : t('header.switchToDark')}
        >
            {isDarkTheme ? <FiSun aria-hidden /> : <FiMoon aria-hidden />}
        </button>
    );
};

ThemeToggle.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(['header', 'surface']),
};

export default ThemeToggle;
